import { FC } from 'react'
import cn from './index.module.css'
import { PlusOutlined } from '@ant-design/icons'

interface IAddGoalCard {
  onClick: () => void
}

const AddGoalCard: FC<IAddGoalCard> = ({ onClick }) => {
  return (
    <div className={cn.wrapper} onClick={onClick}>
      <PlusOutlined
        className={cn.icon}
        onPointerEnterCapture={undefined}
        onPointerLeaveCapture={undefined}
      />
      <div className={cn.title}>Добавить цель</div>
    </div>
  )
}

export default AddGoalCard
